import Vue from 'vue';
import '@/components/Questions';
import '@/components/skeletonShimmer';
import svgComponents from '@/components/svg';

Vue.component('VButton', () => import('@/components/commons/VButton.vue'));
Vue.component('VInput', () => import('@/components/commons/VInput.vue'));
Vue.component('VSelect', () => import('@/components/commons/VSelect.vue'));
Vue.component('Modal', () => import('@/components/modal/Modal.vue'));
Vue.component('ModalLayoutDefault', () => import('@/components/modal/layouts/ModalLayoutDefault.vue'));

svgComponents.forEach(item => {
  Vue.component(item[0], item[1]);
});
